import styled from 'styled-components';
import { TypographyStyles, colours, media, spacing } from '../../../../stylings';

export const Header = styled.span`
  display: flex;
  height: 24px;
  justify-content: space-between;
  width: 100%;
  @media ${media.greaterThan('lg')} {
    height: 28px;
  }
`;

export const HeaderText = styled.span`
  ${TypographyStyles.Body.Medium.SemiBold}
  color: ${colours.BLACK};
  margin: 0;
  padding: 0;
`;

export const ClearAll = styled.button`
  ${TypographyStyles.CallToAction.Tiny.SemiBold}
  background-color: ${colours.WHITE};
  border: none;
  color: ${colours.BLACK};
  text-decoration: underline;
`;

export const ItemList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing.XXXS};
  margin: 0;
  padding: 0;
`;

export const Item = styled.li`
  margin: 0;
  padding: 0;
`;

export const Container = styled.span<{ $isVisible: boolean }>`
  align-items: flex-start;
  border-top: 1px solid ${colours.BLACK};
  box-sizing: border-box;
  display: ${({ $isVisible }) => ($isVisible ? 'flex' : 'none')};
  flex-direction: column;
  gap: 22px;
  padding: ${spacing.XS} 0px 0px;
  width: 100%;

  @media ${media.greaterThan('lg')} {
    align-items: flex-start;
    border-style: solid;
    border-top: none;
    border-width: 1px 0px;
    gap: 20px;
    padding: ${spacing.M} 0px;
    width: 302px;
  }
`;

export const ShowMoreButton = styled.button`
  ${TypographyStyles.CallToAction.Tiny.SemiBold}
  align-items: center;
  background: none;
  border: 0;
  color: ${colours.BLACK};
  display: flex;
  padding: 0 ${spacing.XXS} 0 0;
  text-align: left;
  text-decoration: underline;

  svg {
    display: inline-block;
    overflow: visible;
    transform: scale(0.5);
  }
`;

export const ShowMoreContainer = styled.div`
  align-items: center;
  display: flex;
  gap: ${spacing.XXXXS};
`;
